@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<div class="results">
  <div class="inputRow">
    <input class="inputBox" [(ngModel)]="criteria.searchTerm" (keyup.enter)="search()"
      [disabled]="isBusy()" placeholder="Search Term"/>
    <select class="orderTypeSelection" [(ngModel)]="criteria.searchOrderType" [disabled]="isBusy()">
      <option value="ALL">All Order Types</option>
      <option value="PARTS_ONLY">Only Parts and Warranty Orders</option>
      <option value="UNITS_ONLY">Only Unit Orders</option>
    </select>
    @if (organizations()) {
      <select [(ngModel)]="criteria.orgUnitId" class="userSelection">
        <option value="">Show All Rep Offices</option>
        @for (organization of organizations(); track organization) {
          <option [value]="organization.code"
            >{{ organization.description }}
          </option>
        }
      </select>
    }
    @if (regions()) {
      <select [(ngModel)]="criteria.region" class="userSelection">
        <option value="">Show All Regions</option>
        @for (region of regions(); track region) {
          <option [value]="region.code">{{ region.description }}</option>
        }
      </select>
    }
    <button class="toolbarButton" matButton="text" [disabled]="isBusy()" (click)="search()">
      <mat-icon class="size-16">search</mat-icon>
      <label class="buttonLabel">Search</label>
    </button>
    <span class="spacer"></span>
    @if (newEntityAvailable()) {
      <button class="toolbarButton" matButton="text" [disabled]="isBusy()" (click)="newQuote()">
        <mat-icon class="size-16">add</mat-icon>
        <label class="buttonLabel">New</label>
      </button>
    }
    @if (entityName() == 'CONTRACT') {
      <button class="toolbarButton" matButton="text" [disabled]="isBusy()"
        (click)="navigateToRecentReleases(criteria.orgUnitId)">
        <label>Recent Releases</label>
      </button>
    }
  </div>
  <div class="paginatorRow">
    <mat-paginator class="paginator" [pageSizeOptions]="[25, 50, 100]" [pageSize]="25" [showFirstLastButtons]=true></mat-paginator>
    @if (isBusy()) {
      <mat-progress-spinner mode="indeterminate" class="spinner" diameter="24"></mat-progress-spinner>
    }
    @if (warningMessage()) {
      <div class="warningMessage">
        {{ warningMessage() }}
      </div>
    }
  </div>
  <table mat-table [dataSource]="searchResults" matSort class="paginatedTable bordered-table">
    <ng-container matColumnDef="entityId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="entityId">ID</th>
      <td class="centered-cell" mat-cell *matCellDef="let record">{{ record.entityId }}</td>
    </ng-container>
    <ng-container matColumnDef="projectName">
      <th class="widerCell" mat-header-cell *matHeaderCellDef mat-sort-header>Project Name</th>
      <td mat-cell *matCellDef="let record">{{ record.projectName }}</td>
    </ng-container>
    <ng-container matColumnDef="createTimestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
      <td mat-cell *matCellDef="let record">{{ record.createTimestamp | date: 'MM/dd/yyyy':'UTC' }}</td>
    </ng-container>
    <ng-container matColumnDef="contractTypeDescription">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type Code</th>
      <td mat-cell *matCellDef="let record">{{ record.contractTypeDescription }}</td>
    </ng-container>
    <ng-container matColumnDef="poNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>PO Number</th>
      <td mat-cell *matCellDef="let record">{{ record.poNumber }}</td>
    </ng-container>
    <ng-container matColumnDef="finalExtendedAmount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
      <td class="centered-cell" mat-cell
        *matCellDef="let record">{{ record.finalExtendedAmount | currency: 'USD' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="salesRep">
      <th class="widerCell" mat-header-cell *matHeaderCellDef mat-sort-header>Rep Name</th>
      <td class="centered-cell" mat-cell *matCellDef="let record">{{ record.salesRep }}</td>
    </ng-container>
    <ng-container matColumnDef="responsibility">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Responsibility</th>
      <td class="centered-cell" mat-cell *matCellDef="let record">{{ record.responsibility }}</td>
    </ng-container>
    <ng-container matColumnDef="approvalStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Approval Status</th>
      <td class="centered-cell" mat-cell *matCellDef="let record">{{ record.approvalStatus }}</td>
    </ng-container>
    <ng-container matColumnDef="totalUnitQty">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Quantity</th>
      <td mat-cell *matCellDef="let record">{{ record.totalUnitQty }}</td>
    </ng-container>
    <ng-container matColumnDef="leadTime">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Lead Time</th>
      <td mat-cell *matCellDef="let record">{{ record.leadTime }}</td>
    </ng-container>
    <ng-container matColumnDef="smallTextUserField3">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Process Status</th>
      <td mat-cell *matCellDef="let record">{{ record.smallTextUserField3 }}</td>
    </ng-container>
    <ng-container matColumnDef="numericUserField4">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>IEC Release #</th>
      <td mat-cell *matCellDef="let record">{{ record.numericUserField4 }}</td>
    </ng-container>
    <ng-container matColumnDef="smallTextUserField1">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>IEC Project #</th>
      <td mat-cell *matCellDef="let record">{{ record.smallTextUserField1 }}</td>
    </ng-container>
    <ng-container matColumnDef="levelOfReportingCode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Milestone</th>
      <td mat-cell *matCellDef="let record">{{ record.levelOfReportingCode }}</td>
    </ng-container>
    <ng-container matColumnDef="updateTimestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Update</th>
      <td mat-cell *matCellDef="let record">{{ record.updateTimestamp | date: 'MM/dd/yyyy':'UTC' }}</td>
    </ng-container>
    <ng-container matColumnDef="region">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Region</th>
      <td mat-cell *matCellDef="let record">{{ record.region }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr (click)="rowSelected(row)" class="clickableRow" [class.selectedRow]="isSelected(row)"
    mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>

